import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, catchError, map, throwError } from 'rxjs';
import { BackendApiService } from 'src/app/service/backend-api.service';
import { User } from 'src/app/model/userKeycloak.model';
import { Beneficiary } from 'src/app/model/beneficiary.model';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

interface Gender {
  name: string;
  value: number
}

interface Profile {
  name: string;
  value: number
}

interface Role {
  name: string;
  value: number;
  profil:number
}

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  genders!: Gender[];
  roles!: Role[];
  profiles!: Profile[];
  userId!: string;

  userForm!: FormGroup;
  selectedGender: any;
  selectedRole!: any;
  beneficiaryIsCreated$!: Observable<any>;
  titleCard: string|undefined;

  error!:boolean
  inValid!: boolean;
  inValidemailId!: boolean;
  inValidpassword!: boolean;
  inValidfirstname!: boolean;
  inValidlastname!: boolean;
  inValidselectedGender!: boolean;
  inValidphoneNumberOne!: boolean;


  constructor(
      private formBuilder: FormBuilder,
      private authService: AuthService,
      private router : Router,
      private route : ActivatedRoute
  ) {}

  token!: string;
  ngOnInit() {
      
      this.initGender();
      this.initProfile();
      this.titleCard = "Créer un compte";

    this.route.queryParams.subscribe((data) =>{

        if(data===null){
            this.userForm = this.formBuilder.group({
                //userName: [null],
                emailId: [null,Validators.required],
                password: [null,Validators.required],
                firstname: [null,Validators.required],
                lastname: [null,Validators.required],
                selectedGender: new FormControl<Gender | null>(null,Validators.required),
                selectedProfile: new FormControl<Profile | null>(null),
                selectedRole: new FormControl<Role | null>(null),
                phoneNumberOne: [null,Validators.required],
            });   
        }else{
            this.userForm = this.formBuilder.group({
                //userName: [null],
                emailId: [data['email'],Validators.required],
                password: [null,Validators.required],
                firstname: [data['firstname'],Validators.required],
                lastname: [data['lastname'],Validators.required],
                selectedGender: new FormControl<Gender | null>(null,Validators.required),
                selectedProfile: new FormControl<Profile | null>(null),
                selectedRole: new FormControl<Role | null>(null),
                phoneNumberOne: [null,Validators.required],
            });
        }
   
      })
      
  }

  onSubmitForm() {

    if(this.userForm.invalid){
      this.inValid=true;
      const formValue = this.userForm.value;
    
      if(formValue['emailId'] ==undefined || formValue['emailId'] == null || formValue['emailId'] == "" ){
          this.inValidemailId = true;
      }else{
        this.inValidemailId = false;
      }
      if(formValue['password'] == undefined || formValue['password'] == null || formValue['password'] == "" ){
        this.inValidpassword=true;
      }else{
        this.inValidpassword=false;
      }
      if(formValue['firstname'] == undefined || formValue['firstname'] == null || formValue['firstname'] == "" ){
        this.inValidfirstname=true;
      }else{
        this.inValidfirstname=false;
      }

      if(formValue['lastname'] == undefined || formValue['lastname'] == null || formValue['lastname'] == "" ){
            this.inValidlastname=true;
      }else{
        this.inValidlastname=false;
      }
      if(formValue['selectedGender'] == undefined || formValue['selectedGender'] == null || formValue['selectedGender'] == "" ){
        this.inValidselectedGender=true;
      }else{
        this.inValidselectedGender=false;
      }
      if(formValue['phoneNumberOne'] == undefined || formValue['phoneNumberOne'] == null || formValue['phoneNumberOne'] == "" ){
        this.inValidphoneNumberOne=true;
      }else{
        this.inValidphoneNumberOne=false;
      }
     

    
    }else{  
      const formValue = this.userForm.value;

      //// //console.log(formValue['selectedProfile'])

      const newProfile = {
        // id: formValue[''],
        // name: formValue['selectedProfile'].name,
        id: formValue['selectedProfile'].profil
      };

      const newRole = {
        // name: formValue['selectedRole'].name,
        // value: formValue['selectedRole'].value,
        id: formValue['selectedProfile'].value 
      };

      const newUser = new User(
          formValue['emailId'], //ici on defini que le username est l'email
          formValue['emailId'],
          formValue['password'],
          formValue['password'],
          formValue['firstname'],
          formValue['lastname']
      );

      const newBeneficiary = new Beneficiary(
        formValue['firstname'],
        newProfile,
        newRole,
        // {id:5},
        formValue['lastname'],
        formValue['dateBirth'],
        {id:formValue['selectedGender']},
        formValue['city'],
        formValue['country'],
        formValue['emailId'],
        formValue['phoneNumberOne'],
        formValue['phoneNumberTwo'],
        formValue['password']
    );

    //// //console.log("before created :",newBeneficiary)
    //// //console.log("role :",newRole.id)


      //On appelle l'endpoint pour la creation du user et du beneficiary

        this.authService
           .createBeneficiary(newBeneficiary)
           .pipe()
           .subscribe(
             {next :  (reponse) => {
              
                 if (reponse) {
                     //// //console.log("reponse du servicer :"+reponse);
                   if(reponse.status === 200 || reponse.countExist == true){
                       this.router.navigate(['/auth/message-confirmation']);
                     }else if (reponse.status === 409) {

                      this.inValidemailId= true;
                    alert("Adresse Email déja utilisé")
                      
                     } else {
                      this.error = true;
                      
                      
                     }
                 }
             },error:(err) =>{
                 alert("Erreur de creation de compte");
                 window.location.reload()
             }
             }); 


     /*  this.authService
      .createBeneficiary(newBeneficiary)
           .pipe(
            map((response) => {
              if (response) {
                //// //console.log("Réponse du service :", response);
                if (response.status === 200 || response.countExist === true) {
                  const beneficiaryId = response.id; // Assurez-vous d'ajuster la propriété correspondant à l'ID dans votre réponse
                  const roleId = newBeneficiary.role.id;
      
                  // Appel de la fonction pour ajouter le rôle au bénéficiaire
                  this.authService.addRoleToBeneficiary(beneficiaryId, roleId).subscribe(
                    (addRoleResponse) => {
                      // Gérez la réponse de manière appropriée si nécessaire
                      //// //console.log('Rôle ajouté avec succès', addRoleResponse);
                      this.router.navigate(['/auth/message-confirmation']);
                    },
                    (error) => {
                      console.error('Erreur lors de l\'ajout du rôle', error);
                      // Gérez l'erreur de manière appropriée si nécessaire
                    }
                  );
                } else {
                  this.error = true;
                  window.location.reload();
                }
              }
            }),
            catchError((error) => {
              console.error('Erreur lors de la création du bénéficiaire', error);
              // Gérez l'erreur de manière appropriée si nécessaire
              alert("Erreur de création de compte");
              window.location.reload();
              return throwError(error);
            })
          ); */


      //On appelle l'endpoint pour l'envoi du mail de verification

    }

  }

  initGender() {
      this.genders = [
          { name:'Masculin', value: 1 },
          { name:'Feminin', value: 2 },
      ];
  }

  initProfile() {
      this.roles = [
          { name: 'Je suis un étudiant', value: 1, profil : 1},
          { name: 'Je suis un élève', value: 3, profil : 1},
          { name: 'Je veux entreprendre', value: 2, profil : 1 },
          { name: 'Je suis start-up', value: 5, profil :  5},
      ];
  }

  initForm() {
      this.userForm = this.formBuilder.group({
          //userName: [null],
          emailId: [null],
          password: [null],
          firstname: [null],
          lastname: [null],
          selectedGender: new FormControl<Gender | null>(null),
          selectedProfile: new FormControl<Profile | null>(null),
          selectedRole: new FormControl<Role | null>(null),
          phoneNumberOne: [null],
          
      });
  }

}
